import { useQuery } from "react-query";
import { GetMetodePembayaranResponse } from "../../constants/types";
import axios from "../axios";
import qs from "query-string";

const handleRequest = async (warehouseId?: number | null) => {
    const apiGetMetodePembayaran = qs.stringifyUrl({
        url: "/api/metode-bayar",
        query: {
            warehouseId: warehouseId,
        },
    });
    const { data } = await axios.get<GetMetodePembayaranResponse>(
        apiGetMetodePembayaran,
    );
    return data.data;
};

export default function useMetodePembayaran(warehouseId?: number | null) {
    return useQuery<GetMetodePembayaranResponse["data"]>(
        ["listMetodePembayaran", warehouseId],
        () => handleRequest(warehouseId),
        { enabled: !!warehouseId },
    );
}
